import {TableCellProps} from 'react-markdown/lib/ast-to-react';

import {Text} from '#component/base';

import {tableHeader} from '../Markdown.css';

export const TableHeader = ({children}: React.PropsWithChildren<TableCellProps>) => {
  return (
    <Text as="th" variant="label" color="burgundy" className={tableHeader}>
      {children}
    </Text>
  );
};
